import { render } from "./RemoteAssist.vue?vue&type=template&id=9e79fe1a&scoped=true"
import script from "./RemoteAssist.vue?vue&type=script&lang=js"
export * from "./RemoteAssist.vue?vue&type=script&lang=js"

import "./RemoteAssist.vue?vue&type=style&index=0&id=9e79fe1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e79fe1a"]])

export default __exports__